import "./Header.scss";
import {
    Box,
    Container,
    Grid,
    Toolbar,
} from '@mui/material';

import AppBar from '@mui/material/AppBar';
import BaftaViewTextLogo from "../Components/BaftaViewTextLogo";
import LaunchIcon from "@mui/icons-material/Launch";
import Mask from "../Components/Mask";
import {memo} from "react";
import SettingsMenuWithButton from '../Components/Menu/SettingsMenuWithButton';
import makeStyles from '@mui/styles/makeStyles';
import {useSelector} from "react-redux";
import { Link } from 'react-router-dom';
import BasicButton from "../Components/Buttons/BasicButton";

const useStyles = makeStyles((theme) => ({
    headerRoot: {
        flexGrow: 1,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.light,
        padding: `${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(1)}`,
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
            paddingTop: theme.spacing(2)
        },
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(1),
            paddingTop: theme.spacing(2)
        },
        '& .MuiInputBase-input:focus .MuiInputBase-root' : {
            backgroundColor: '#676767',
            border:'1px solid #fff'
        }
    },
    topHeaderToolbar: {
        minHeight: '80px'
    },
    viewLogo: {
        textAlign:'center',
    },
    baftaViewLogoLink: {
        margin: 'auto',
        display: 'table',
        color: theme.palette.secondary.contrastText,
        textDecoration: 'none',

        "&:hover": {
            textDecoration: "none",
        },
    },
}));

export default memo(function Header ({ className = "", pad = true, ...props }) {
    const classes = useStyles();
    const user = useSelector(state => state.user.user);

    return (
        <>
            <AppBar className={`${classes.headerRoot} ${!pad ? 'Header--nopad':''} ${className}`} elevation={0} {...props} position="static">
                <Toolbar disableGutters={true} className={classes.topHeaderToolbar}>
                    <Container maxWidth="xl">
                        <Grid container direction="row" justifyContent="center" alignItems="center">
                            <Grid item md={4} lg={4} xs={4} sm={4}>
                                <Mask />
                            </Grid>
                            <Grid item md={4} lg={4} xs={4} sm={4} className={classes.viewLogo}>
                                <Link to="/" className={classes.baftaViewLogoLink}>
                                    <BaftaViewTextLogo />
                                </Link>
                            </Grid>
                            <Grid item md={4} lg={4} xs={4} sm={4}>
                                <Box display="flex" justifyContent="flex-end" alignItems="center">
                                    <div className="Header__votelinkwrap">
                                        <BasicButton 
                                            className="Header__votelink"
                                            href="https://voting.bafta.org" 
                                            target="_blank" 
                                            startIcon={LaunchIcon}
                                        >
                                            Vote
                                        </BasicButton>
                                    </div>
                                    
                                    <SettingsMenuWithButton user={user} />
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Toolbar>
            </AppBar>
        </>
    );
});